import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { InputModel } from '../../models/input/input.model';
import { DatatableFilterModel } from '../../models/datatable/datatable-filter.model';
import { DatatableFilterStylingModel } from '../../models/datatable/datatable-filter-styling.model';
import { DatatableFilterTemplates } from '../../templates/datatable-filter.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CfDatatableFilter component is used to filter datatable rows</p>
 * <pre>
 * <code>
 * <code><</code>cf-datatable-filter<code>></code><code><</code><code>/</code>cf-datatable-filter<code>></code>
 * </code>
 * </pre>
 */
export class CfDatatableFilterComponent extends CfCoreComponent implements OnInit {
/**
 * <pre>{{'{'}}
 * 	filterProperty: InputModel,
 * {{'}'}}</pre>
 * <h4>filterProperty: InputModel</h4>
 * CfInput component for the filter.
 * <p>Example:</p>
 * <pre>{{'{'}}
 * 		filterProperty: this.myInput
 * {{'}'}}</pre>
 */
properties: DatatableFilterModel;
/**
 * <p> dynamicClass: function() -> string,	// Function that returns name of the class </p>
 * <p> class: string											  // Name of the css class selector </p>
 * <p> themeColor: string									// primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 * 	// Main container
 * 	container: {{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}},
 * 	// Filter element
 * 	inputFilter: InputStylingModel, //refer to input component
 * }
 * </pre>
 * <p>Example:<p>
 * <pre>
 * 	new DatatableFilterStylingModel({{'{'}}
 * 		container: {{'{'}}class: 'my-datatable-filter'{{'}'}},
 * 		inputFilter: new InputStylingModel({{'{'}}
 * 			iconStyling: new IconStylingModel({{'{'}} icon: {{'{'}} themeColor: "primary" {{'}'}} {{'}'}})
 * 		{{'}'}}),
 * 	{{'}'}})
 * </pre>
 */
styling: DatatableFilterStylingModel;
/**
 * CfInput component for the filter
 * @param {?} value
 * @return {?}
 */
set inputProperty(value: InputModel) { this.properties.inputProperty = value; }
/**
 * @hidden 
 * Emit event on input value changes
 */
onFilter = new EventEmitter();
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new DatatableFilterModel();
    this.styling = new DatatableFilterStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('datatable-filter', DatatableFilterTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'DATATABLE-FILTER').then(sampler => {
        // console.log('DATATABLE-FILTER', this);
      });
    });
  }
/**
 * @hidden 
 * Function to run event emiter and send text value from input
 * @param {?} value
 * @return {?}
 */
onValueChange(value) { this.onFilter.emit(value); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-datatable-filter',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-datatable-filter'\">	 <cf-input [properties]=\"properties?.inputProperty\" [styling]=\"styling?.inputStyling\" (valueChange)=\"onValueChange($event)\"></cf-input> </div>",
  styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'inputProperty': [{ type: Input, args: ['inputProperty', ] },],
'onFilter': [{ type: Output },],
};
}

function CfDatatableFilterComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfDatatableFilterComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfDatatableFilterComponent.ctorParameters;
/** @type {?} */
CfDatatableFilterComponent.propDecorators;
/**
 * <pre>{{'{'}}
 * 	filterProperty: InputModel,
 * {{'}'}}</pre>
 * <h4>filterProperty: InputModel</h4>
 * CfInput component for the filter.
 * <p>Example:</p>
 * <pre>{{'{'}}
 * 		filterProperty: this.myInput
 * {{'}'}}</pre>
 * @type {?}
 */
CfDatatableFilterComponent.prototype.properties;
/**
 * <p> dynamicClass: function() -> string,	// Function that returns name of the class </p>
 * <p> class: string											  // Name of the css class selector </p>
 * <p> themeColor: string									// primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 * 	// Main container
 * 	container: {{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}},
 * 	// Filter element
 * 	inputFilter: InputStylingModel, //refer to input component
 * }
 * </pre>
 * <p>Example:<p>
 * <pre>
 * 	new DatatableFilterStylingModel({{'{'}}
 * 		container: {{'{'}}class: 'my-datatable-filter'{{'}'}},
 * 		inputFilter: new InputStylingModel({{'{'}}
 * 			iconStyling: new IconStylingModel({{'{'}} icon: {{'{'}} themeColor: "primary" {{'}'}} {{'}'}})
 * 		{{'}'}}),
 * 	{{'}'}})
 * </pre>
 * @type {?}
 */
CfDatatableFilterComponent.prototype.styling;
/**
 * @hidden 
 * Emit event on input value changes
 * @type {?}
 */
CfDatatableFilterComponent.prototype.onFilter;
/** @type {?} */
CfDatatableFilterComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
